<template>
  <Layout>
    <template v-slot:title>Error en el Servidor</template>
    <p>
      Estamos teniendo algún problema con nuestro servidor. Por favor, inténtalo
      de nuevo pasados unos minutos
    </p>
  </Layout>
</template>

<script>
import Layout from '@/layouts/ErrorLayout'

export default {
  components: { Layout },
}
</script>
